export default "__VITE_ASSET__Ohhyl620__"